"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.broadcastTransaction = exports.getFees = exports.getOperations = exports.getNetworkConfig = exports.getValidators = exports.getAccount = void 0;
var bignumber_js_1 = require("bignumber.js");
var apiCalls_1 = __importDefault(require("./apiCalls"));
var env_1 = require("../../../env");
var operation_1 = require("../../../operation");
var cache_1 = require("../cache");
var api = new apiCalls_1["default"]((0, env_1.getEnv)("ELROND_API_ENDPOINT"));
/**
 * Get account balances and nonce
 */
var getAccount = function (addr) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, balance, nonce, blockHeight;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, api.getAccountDetails(addr)];
            case 1:
                _a = _b.sent(), balance = _a.balance, nonce = _a.nonce;
                return [4 /*yield*/, api.getBlockchainBlockHeight()];
            case 2:
                blockHeight = _b.sent();
                return [2 /*return*/, {
                        blockHeight: blockHeight,
                        balance: new bignumber_js_1.BigNumber(balance),
                        nonce: nonce
                    }];
        }
    });
}); };
exports.getAccount = getAccount;
var getValidators = function () { return __awaiter(void 0, void 0, void 0, function () {
    var validators;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.getValidators()];
            case 1:
                validators = _a.sent();
                return [2 /*return*/, {
                        validators: validators
                    }];
        }
    });
}); };
exports.getValidators = getValidators;
var getNetworkConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.getNetworkConfig()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getNetworkConfig = getNetworkConfig;
/**
 * Returns true if account is the signer
 */
function isSender(transaction, addr) {
    return transaction.sender === addr;
}
/**
 * Map transaction to an Operation Type
 */
function getOperationType(transaction, addr) {
    return isSender(transaction, addr) ? "OUT" : "IN";
}
/**
 * Map transaction to a correct Operation Value (affecting account balance)
 */
function getOperationValue(transaction, addr) {
    var _a, _b, _c;
    return isSender(transaction, addr)
        ? new bignumber_js_1.BigNumber((_a = transaction.value) !== null && _a !== void 0 ? _a : 0).plus((_b = transaction.fee) !== null && _b !== void 0 ? _b : 0)
        : new bignumber_js_1.BigNumber((_c = transaction.value) !== null && _c !== void 0 ? _c : 0);
}
/**
 * Map the Elrond history transaction to a Ledger Live Operation
 */
function transactionToOperation(accountId, addr, transaction) {
    var _a, _b, _c;
    var type = getOperationType(transaction, addr);
    return {
        id: (0, operation_1.encodeOperationId)(accountId, (_a = transaction.txHash) !== null && _a !== void 0 ? _a : "", type),
        accountId: accountId,
        fee: new bignumber_js_1.BigNumber(transaction.fee || 0),
        value: getOperationValue(transaction, addr),
        type: type,
        hash: (_b = transaction.txHash) !== null && _b !== void 0 ? _b : "",
        blockHash: transaction.miniBlockHash,
        blockHeight: transaction.round,
        date: new Date(transaction.timestamp ? transaction.timestamp * 1000 : 0),
        extra: {},
        senders: [(_c = transaction.sender) !== null && _c !== void 0 ? _c : ""],
        recipients: transaction.receiver ? [transaction.receiver] : [],
        transactionSequenceNumber: isSender(transaction, addr)
            ? transaction.nonce
            : undefined,
        hasFailed: !transaction.status ||
            transaction.status === "fail" ||
            transaction.status === "invalid"
    };
}
/**
 * Fetch operation list
 */
var getOperations = function (accountId, addr, startAt) { return __awaiter(void 0, void 0, void 0, function () {
    var rawTransactions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.getHistory(addr, startAt)];
            case 1:
                rawTransactions = _a.sent();
                if (!rawTransactions)
                    return [2 /*return*/, rawTransactions];
                return [2 /*return*/, rawTransactions.map(function (transaction) {
                        return transactionToOperation(accountId, addr, transaction);
                    })];
        }
    });
}); };
exports.getOperations = getOperations;
/**
 * Obtain fees from blockchain
 */
var getFees = function (unsigned) { return __awaiter(void 0, void 0, void 0, function () {
    var data, _a, gasLimit, gasPerByte, gasPrice;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                data = unsigned.data;
                return [4 /*yield*/, (0, cache_1.getTransactionParams)()];
            case 1:
                _a = _b.sent(), gasLimit = _a.gasLimit, gasPerByte = _a.gasPerByte, gasPrice = _a.gasPrice;
                if (!data) {
                    return [2 /*return*/, new bignumber_js_1.BigNumber(gasLimit * gasPrice)];
                }
                return [2 /*return*/, new bignumber_js_1.BigNumber((gasLimit + gasPerByte * data.length) * gasPrice)];
        }
    });
}); };
exports.getFees = getFees;
/**
 * Broadcast blob to blockchain
 */
var broadcastTransaction = function (blob) { return __awaiter(void 0, void 0, void 0, function () {
    var hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.submit(blob)];
            case 1:
                hash = (_a.sent()).hash;
                // Transaction hash is likely to be returned
                return [2 /*return*/, hash];
        }
    });
}); };
exports.broadcastTransaction = broadcastTransaction;
//# sourceMappingURL=sdk.js.map